import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

const  AlertDialog = ({ title, msg, agreeText="Yes", disagreeText="No", open, handleClose, onAgree,loading=false }) => {

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {msg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose} color="primary" size="small" variant="contained" style={{color:"White" }}>
            {disagreeText}
          </Button>
          <Button onClick={onAgree} color="primary" size="small" variant="contained" autoFocus style={{color:"White" }}>
            {agreeText}
          </Button>
        </DialogActions>
      </Dialog>
  );
}


export default AlertDialog;